import { Link as RadixLink } from "@lyteflo/components";
import type { ComponentProps } from "preact";
import { Link as WouterLink } from "wouter";

type LinkProps = ComponentProps<typeof RadixLink> & {
  href: string;
  className?: string;
};

export const Link = ({ href, className, children, ...props }: LinkProps) => {
  const isExternal = /^https?:\/\//.test(href);

  return (
    <RadixLink asChild className={className} {...props}>
      {isExternal ? (
        <a href={href} target="_blank" rel="noreferrer">
          {children}
        </a>
      ) : (
        <WouterLink to={href}>{children}</WouterLink>
      )}
    </RadixLink>
  );
};
